export const oimStatementConfig = {
    formData: 'oimMainUpdateForm',
    rateData: 'oimRateUpdateForm',
    hasCY: true,
    hasRail: true,
    hasCFS: true,
    hasMBL: true,
    hasRate: true,
    hasClose: true,
    tableName: 'il_ocean_import',
    keyName: ['il_ocean_import_id'],
    reducerActions: ['setOimMainUpdateData'],

    sections: [
        {
            label: 'Collect Charge',
            cols: 'oceanFreightCols',
            history: ['ocean_freight', 'paid_with', 'paid_on', 'ocean_freight_link'],
        },
    ],
};

export const oexStatementConfig = {
    formData: 'oexMainUpdateForm',
    rateData: 'oexRateUpdateForm',
    hasCY: false,
    hasRail: true,
    hasCFS: true,
    hasMBL: false,
    hasRate: true,
    hasClose: true,
    tableName: 'il_ocean_export',
    keyName: ['il_ocean_export_id'],
    reducerActions: ['setOexMainUpdateData'],
    sections: [
        {
            label: 'Booking Confirmation',
            cols: 'bookingConfirmationCols',
            history: ['booking_confirmation', 'booking_confirmation_date'],
        },
        {
            label: 'Collect Charge',
            cols: 'oceanFreightCols',
            history: ['ocean_freight', 'paid_with', 'paid_on', 'ocean_freight_link'],
        },
    ],
};

export const aimStatementConfig = {
    formData: 'aimMainUpdateForm',
    rateData: 'aimRateUpdateForm',
    hasCY: true,
    hasRail: false,
    hasCFS: true,
    hasMBL: false,
    hasRate: true,
    hasClose: true,
    tableName: 'il_air_import',
    keyName: ['il_air_import_id'],
    reducerActions: ['setAimMainUpdateData'],

    sections: [
        {
            label: 'Collect Charge',
            cols: 'airFreightCols',
            history: ['air_freight', 'paid_with', 'paid_on', 'air_freight_link'],
        },
    ],
};

export const aexStatementConfig = {
    formData: 'aexMainUpdateForm',
    rateData: 'aexRateUpdateForm',
    hasCY: true,
    hasRail: false,
    hasCFS: true,
    hasMBL: false,
    hasRate: true,
    hasClose: true,
    tableName: 'il_air_export',
    keyName: ['il_air_export_id'],
    reducerActions: ['setAexMainUpdateData'],

    sections: [
        {
            label: 'Booking Confirmation',
            cols: 'bookingConfirmationCols',
            history: ['booking_confirmation', 'booking_confirmation_date'],
        },
        { label: 'DG/HAZMAT', cols: 'dgHazmatCols', history: ['dg_hazmat', 'dg_hazmat_link', 'dg_hazmat_date'] },
        {
            label: 'Shipping Instruction',
            cols: 'siCols',
            history: ['shipping_instruction', 'shipping_instruction_date'],
        },
        { label: 'AES ITN', cols: 'aesCols', history: ['aes_itn', 'aes_itn_number', 'aes_itn_date'] },
        {
            label: 'Collect Charge',
            cols: 'airFreightCols',
            history: ['air_freight', 'paid_with', 'paid_on', 'air_freight_link'],
        },
    ],
};

export const truckingStatementConfig = {
    formData: 'truckingMainUpdateForm',
    rateData: 'truckingRateUpdateForm',
    hasCY: false,
    hasRail: false,
    hasCFS: true,
    hasMBL: false,
    hasRate: true,
    hasClose: true,
    tableName: 'il_ftl_ltl',
    keyName: ['il_ftl_ltl_id'],
    reducerActions: ['setTruckingMainUpdateData'],

    sections: [
        { label: 'Invoice', cols: 'invoiceCols', history: ['invoice', 'invoice_link', 'invoice_date'] },
        { label: 'Credit/Debit Note', cols: 'crdrCols', history: ['crdr', 'crdr_link', 'crdr_date'] },
    ],
};
